module.exports = __webpack_public_path__ + "img/pass-it-down-mobile_398x294.a22fe6e0.jpg";